export const VERTICAL_OFFSET_SB_RESP_IMG = 500;
export const VERTICAL_OFFSET_RESP_IMG = 500;
export const HORIZONTAL_OFFSET_RESP_IMG = 300;

export const VERTICAL_OFFSET_MOBILE_IMG = 500;
export const HORIZONTAL_OFFSET_MOBILE_IMG = 300;
